<template>
  <bb-modal
    v-if="modalOpened"
    maxWidth="425px"
    noPadding
    closeIconLarge
    smallModalBox
    @close="handleCloseModal"
  >
    <div class="modal-content">
      <!-- <lottie
        class="confetti-animation"
        autoHeight
        :options="lotties.confettiAnimation"
      /> -->
      <div class="content-wrapper">
        <header class="header">
          <span class="text">¡Sumaste crédito para tu próxima compra!</span>
        </header>
        <router-link
          :to="{ name: 'accountCredit' }"
          class="credit-redirect-button"
          >Ver mi crédito</router-link
        >
      </div>
    </div>
  </bb-modal>
</template>

<script>
  // Animacion comentada porque falta definir cosas del lado del diseño .
  import Vue from 'vue';
  import Component from 'vue-class-component';
  // import * as confettiAnimation from 'assets/lotties/confettiAnimation.json';
  // import Lottie from 'vue-lottie';
  import BbModal from 'common/components/BbModal/BbModal.vue';
  import { useAccountStore } from 'stores/account';
  import { Watch } from 'vue-property-decorator';

  @Component({
    components: {
      BbModal,
      // Lottie,
    },
    props: {
      creditReferences: {
        required: true,
        type: Array,
      },
    },
  })
  export default class RefundCredits extends Vue {
    modalOpened = false;
    // lotties = {
    //   confettiAnimation: {
    //     animationData: confettiAnimation.default,
    //     loop: false,
    //     autoplay: true,
    //   },
    // };
    get isBigboxPlus() {
      return useAccountStore().getUserIsBigboxPlus;
    }
    get isCashbackPurchase() {
      return this.creditReferences
        .map(element => element.reference)
        .includes(this.$route.query.backFromCheckout);
    }
    isBigboxPlusRefundable() {
      return this.isCashbackPurchase && this.isBigboxPlus;
    }
    handleCloseModal() {
      this.modalOpened = false;
    }
    
    @Watch('isCashbackPurchase')
    @Watch('isBigboxPlus')
    onUserOrPurchaseChanged() {
      this.modalOpened = this.isBigboxPlusRefundable();
    }
  }
</script>

<style scoped>
  .modal-content {
    position: relative;
    background-color: white;
    text-align: left;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 32px;
    min-height: 15rem;
    justify-content: center;
    padding-inline: 16px;
    padding-bottom: 40px;
    border: 0 0 5px 0;
    border-radius: 5px;
  }

  .confetti-animation {
    position: absolute;
    z-index: 0;
    top: -55px;
    left: 0;
    width: 100%;
    height: auto;
  }

  .content-wrapper {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .header,
  .button-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
  }

  .text {
    color: #464646;
    font-size: 20px;
    font-family: Figtree;
    font-weight: 600;
    line-height: 26px;
    word-wrap: break-word;
  }

  .credit-redirect-button {
    align-self: stretch;
    padding: 16px 24px;
    background: #222222;
    border-radius: 8px;
    color: white;
    font-size: 16px;
    font-family: Figtree;
    font-weight: 600;
    line-height: 20px;
    cursor: pointer;
    text-align: center;
  }
</style>
